<template>
  <div class="userList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入热搜词"
        clearable
        v-model="searchParam.keyword"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input>
      <!-- <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker> -->
      <el-button type="primary" size="small" @click="refreshSearch"
        >搜索</el-button
      >
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="520"
    >
      <el-table-column
        prop="keyword"
        label="搜索词"
        align="center"
        min-width="120"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.keyword || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="count"
        label="次数"
        align="center"
        fixed
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.count }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 20, 30]"
      :current-page="searchParam.pageNumber"
      :page-size="searchParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <el-dialog
      title="添加会员卡"
      :visible.sync="isBindVip"
      width="400px"
      @close="bindVipClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" label-width="140px">
        <div class="form_item">
          <div class="form_item_name">会员卡</div>
          <el-select v-model="bindVipCard" clearable="" size="small">
            <el-option
              v-for="item in vipList"
              :key="item.id"
              :label="item.newName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isBindVip = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="confirmBind" size="medium"
          >确 认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="发送私信"
      :visible.sync="msgDialogVisible"
      width="600px"
      @close="close"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="80px">
        <!-- <el-form-item label="用户ID:" prop="content">
          <el-input
            v-model.number="msgData.takeUid"
            disabled
            size="small"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="图片:" prop="cover">
          <base-upload
            class="upload"
            :cover="msgData.imgUrl[0]"
            :action="action"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item> -->
        <el-form-item label="内容:" prop="content">
          <el-input
            v-model="msgData.content"
            type="textarea"
            rows="3"
            size="small"
            style="width: 100%;"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="msgDialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="sendComment"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
// import { changeTime } from "@/utils/global";
import API from "@/api";
import { sortEscape } from "@/utils/global";
import { validatorMobile } from "@/utils/validator";
export default {
  data() {
    return {
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      dialogFormVisible: false,
      banTableData: [],
      uid: "",
      auth: true,
      banTotal: "",
      banLoading: false,
      form: {
        phone: "",
      },
      imgUrl: baseConfig.imgUrl,
      roleList: [
        { value: "snap", label: "普通用户" },
        { value: "user", label: "VIP用户" },
      ],
      vipLevelList: [
        { value: 0, label: "非VIP" },
        { value: 1, label: "VIP" },
        { value: 2, label: "超级VIP" },
        { value: 3, label: "暗网会员" },
      ],
      hadPromotList: [
        { value: true, label: "有" },
        { value: false, label: "无" },
      ],
      rules: {
        phone: [
          {
            required: true,
            message: "请输入正确格式的手机号码",
            trigger: "blur",
          },
          { validator: validatorMobile, trigger: "blur" },
        ],
      },
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      // 封禁理由列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      vipList: [],
      bindVipCard: "",
      isBindVip: false,
      bindUid: "",
      // 用户管理列表请求参数
      searchParam: {
        pageNumber: 1,
        pageSize: 10,
        keyword: "",
        // start: "",
        // end: "",
      },
      msgDialogVisible: false,
      flag: false,
      msgData: {
        takeUid: undefined,
        content: "",
        // imgUrl: "",
      },
    };
  },
  created() {
    this.auth = true;
    this.getList(this.searchParam);
    // this.queryVipCard();
    // this.auth = validatorAuthority();
    // this.getUserList(this.searchParam);
  },
  methods: {
    async sendComment() {
      this.flag = true;
      try {
        let res = await API.sendMessage(this.msgData);
        this.flag = false;
        if (res && res.code == 200) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "发送失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$message({
          message: "发送失败",
          type: "error",
        });
        this.flag = false;
      }
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.msgData.imgUrl = [res.data.coverImg];
    },
    udpateForbid(row, type) {
      const params = Object.assign(
        {},
        {
          uidList: [row.uid],
          enable: type,
        }
      );
      API.resetForbid(params)
        .then((res) => {
          res.code === 200 &&
            (this.$message.success("修改用户禁止上传文件状态成功！"),
            this.getList(this.searchParam));
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        });
    },
    openPrivateLetter(row) {
      this.msgData.takeUid = row.uid;
      this.msgDialogVisible = true;
      // console.log(row);
      // const params = Object.assign(
      //   {},
      //   {
      //     takeUid: row.uid,
      //   }
      // );
      // this.$refs.privateLetter.open(params);
    },
  
    // 时间选择回掉
    // changeTime(time) {
    //   if (time) {
    //     this.searchParam.start = changeTime(time[0]);
    //     this.searchParam.end = changeTime(time[1]);
    //   } else {
    //     this.searchParam.startTime = "";
    //     this.searchParam.endTime = "";
    //   }
    //   this.refreshSearch();
    // },
    // 搜索对应列表
    refreshSearch() {
      this.searchParam.pageNumber = 1;
      this.getList(this.searchParam);
    },
    // 搜索对应列表
    search() {
      this.getList(this.searchParam);
    },
    // 请求用户列表
    getList(obj) {
      this.loading = true;
      API.getHotSearchStatistics(obj)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.searchParam.value = sortEscape(column.order);
      this.searchParam.key = column.prop;
      this.getList(this.searchParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.searchParam.pageSize = size;
      this.searchParam.pageNumber = 1;
      this.getList(this.searchParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.searchParam.pageNumber = pageNumber;
      this.getList(this.searchParam);
    },
    // 编辑用户
    editUser(row) {
      this.$refs.editUser.open(row);
    },
    bindVipClose() {
      this.bindVipCard = "";
      this.bindUid = "";
    },
    confirmBind() {
      if (!this.bindVipCard) {
        this.$message({
          message: "请选择会员卡",
          type: "error",
        });
        return;
      }
      let params = {
        uid: this.bindUid,
        vipID: this.bindVipCard,
      };
      API.editUser(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("goBack");
          } else {
            this.$message.error("添加失败");
          }
          this.isBindVip = false;
        })
        .catch(() => {
          this.isBindVip = false;
        });
    },
    close() {
      this.msgData.takeUid = undefined;
      this.msgData.content = "";
      // this.msgData.imgUrl = "";
    },
  },
};
</script>
<style lang="scss">
.el-message-box {
  .cancel_right {
    float: right;
    margin-left: 10px;
  }
}
</style>
<style scoped lang="scss">
.userList-box {
  .v-number {
    vertical-align: middle;
  }
  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #eb5f84;
    }
  }
  /deep/.col_layout {
    /deep/ div {
      display: flex;
      justify-content: center;
      padding-left: 50px;
      button {
        margin-left: auto;
      }
    }
  }
}
.form_item {
  display: flex;
  align-items: center;
  justify-content: center;
  .form_item_name {
    margin-right: 20px;
  }
}
/deep/ .desc {
  display: none;
}
/deep/ .el-form-item {
  display: flex;
}
/deep/ .el-form-item__content {
  width: 400px;
}
</style>
